

























































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import ListBase from '@/lib/listbase'
import FormBase from '@/components/helper/form-base.vue';
import VWidget from '@/components/VWidget.vue';
import AgreementDocument from '@/store/entities/tracing/agreementdocument';

 
@Component({
    components: { VWidget, FormBase },
})

export default class AgreementDocumentsList extends ListBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    entity: string = "agreementdocument";
    document: AgreementDocument = new AgreementDocument();
    modalShow: boolean = true;
    file: any = null;
    fileData: string = null;
    filename: string = null;
    name: string = null;


    getIcon(filetype) {
        if (filetype == 'pdf')
            return 'mdi-file-pdf-box'
        else if (filetype == 'xls' || filetype == 'xlsx')
            return 'mdi-microsoft-excel'
        else if (filetype == 'doc' || filetype == 'docx')
            return 'mdi-microsoft-word'
        else if (filetype == 'png' || filetype == 'jpg' || filetype == 'jpeg')
            return 'mdi-image'
        else if (filetype == 'avi')
            return 'movie'
        else if (filetype == 'mp4')
            return 'mdi-video'
        else
            return 'mdi-file'
    }

    getColor(filetype) {
        if (filetype == 'pdf')
            return 'error'
        else if (filetype == 'xls' || filetype == 'xlsx')
            return 'green darken-2'
        else if (filetype == 'doc' || filetype == 'docx')
            return 'light-blue darken-4'
        else if (filetype == 'png' || filetype == 'jpg' || filetype == 'jpeg')
            return 'teal'
        else if (filetype == 'avi')
            return 'blue darken-1'
        else if (filetype == 'mp4')
            return 'indigo'
        else
            return 'primary'
    }

    onFileChange(file) {
        if (file != null) {
            let reader = new FileReader();
            let vm = this;
            vm.name = file.name;
            vm.filename = file.name;
            reader.onload = (e) => {
                vm.fileData = (e as any).target.result;
                vm.save();
            };
            reader.readAsDataURL(file);
        }
    }

    async save() {
        if (this.fileData != null) {
            this.document = new AgreementDocument();
            this.document.agreement_id = this.agreement.id;
            this.document.filename = this.filename;
            this.document.name = this.name;
            this.document.fileData = this.fileData;
            await this.$store.dispatch({
                type: 'agreementdocument/upload',
                data: this.document
            });
            //this.document = Util.extend(true, {}, this.$store.state.agreementdocument.editModel);
            this.file = null;
            this.filename = null;
            this.name = null;
            this.fileData = null;
            Util.abp.notify.success(this, 'Tu documento ha sido actualizado!');
            await this.getpage();
        }
    } 

    async deleteFile(item) {
        await this.$store.dispatch({
            type: 'agreementdocument/delete',
            data: item
        });
        await this.getpage();
    }


    /************* COMPUTED LIST ***************/
    get loading() {
        return this.$store.state.agreementdocument.loading || this.$store.state.agreementdocument.itemLoading;
    }

    get list() {
        return this.$store.state.agreementdocument.list;
    }

    get totalCount() {
        return this.$store.state.agreementdocument.totalCount;
    }

    get agreement() {
        return this.$store.state.agreement.editModel;
    }

    /********* EVENTOS DE RETORNO DE MODALES ********/
    async getpage() {
        await this.$store.dispatch({
            type: 'agreementdocument/getAll',
            data: { id: this.agreement.id }
        });
    }

    async mounted() {
        await this.getpage();
    }
}
